enum UserFetchState {
  GOOD = 'GOOD',
  BAD = 'BAD',
  INTERNET_DOWN = 'INTERNET_DOWN',
}

export default UserFetchState;
